export const SERVICES = {
  FETCH_SERVICES_PAGE: {
    MAIN: 'FETCH_SERVICES_PAGE',
    SUCCESS: 'FETCH_SERVICES_PAGE_SUCCESS',
    FAILURE: 'FETCH_SERVICES_PAGE_FAILURE'
  }
};
